import ViewRoutes from "./ViewRoute";

const overviewRoutes = [...ViewRoutes];

export default overviewRoutes;
